import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux/es/exports";
import { appdownload, appstore, googleplay } from "../../assets/img";

function SectionNineThemeTwo() {
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);

  return (
    <>
      <section className="mobapp-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="mobapp-subtract-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mobapp-content">
                      <div className="section-title2">
                        <h2 style={{
                      color: `#${jsonData?.theme_2?.home?.section_9?.h2color}`
                    }}>{jsonData?.theme_2?.home?.section_9?.title}</h2>
                      </div>
                      <p style={{
                      color: `#${jsonData?.theme_2?.home?.section_9?.paracolor}`
                    }}>{jsonData?.theme_2?.home?.section_9?.paragraph}</p>
                      <ul className="applinks">
                        <li>
                          <a
                            target="_blank"
                            href={
                              jsonData?.theme_2?.home?.section_9?.ios_link
                            }
                          >
                            <img src={appstore} alt="" />
                          </a>
                        </li>

                        <li>
                          <a
                            target="_blank"
                            href={jsonData?.theme_2?.home?.section_9?.android_link}
                          >
                            <img src={googleplay} alt="" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mobapp-img text-center">
                      <img src={jsonData?.theme_2?.home?.section_9?.banner} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SectionNineThemeTwo;
